export const TRANSFORM_MILLI_TO_DATE = "MILLI_TO_DATE";
export const TRANSFORM_ROUND_DECIMAL = "ROUND";
export const TRANSFORM_EXCLUDE_KEY = "EXCLUDE_KEY";
export const TRANSFORM_SENTIMENTS_TO_WORDS = "POSITIVE_NEGATIVE";

export const INPUT_TYPE_COMBINED = 'combined';
export const INPUT_TYPE_EXPLORE = 'explore';